import { Typography } from "@suraasa/placebo-ui"
import { Dialog, DialogContent, Theme } from "@suraasa/placebo-ui-legacy"
import { addSeconds } from "date-fns"
import { CheckCircle } from "iconoir-react"
import { useEffect } from "react"
import { useTheme } from "react-jss"
import { useTimer } from "react-timer-hook"
import routes from "routes"

type Props = {
  open: boolean
  parentSelector?: () => void
}

const COUNTDOWN_TIMER = 5

const SubmittedSuccessfullyDialog = (props: Props) => {
  const theme = useTheme<Theme>()
  const { seconds, start } = useTimer({
    onExpire: () => {
      window.location.href = routes.cpat.dashboard
    },
    autoStart: false,
    expiryTimestamp: new Date(addSeconds(new Date(), COUNTDOWN_TIMER)),
  })

  useEffect(() => {
    if (props.open) start()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open])

  return (
    <Dialog width="sm" open={props.open} parentSelector={props.parentSelector}>
      <DialogContent className="m-1 grid content-start">
        <div className="mb-4 mt-1 grid grid-flow-col items-center justify-start gap-2">
          <CheckCircle
            height={30}
            width={30}
            style={{
              backgroundColor: theme.colors.success[500],
              borderRadius: "50%",
              color: theme.colors.common.white[500],
            }}
          />
          <Typography variant="title3">Successfully Submitted!</Typography>
        </div>
        <Typography className="mb-3">
          Congratulations! You have successfully submitted your attempt for this
          assessment.
        </Typography>
        <Typography variant="smallBody" className="text-onSurface-500">
          Note: Redirecting to CPAT dashboard in {seconds} seconds.
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default SubmittedSuccessfullyDialog
